import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import RoomFileUpload from "./RoomFileUpload";

const RoomFootprint = ({ projectId: propProjectId }) => {
  const { projectId: urlProjectId } = useParams();
  const projectId = propProjectId || urlProjectId;

  const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
  const apiRootSecond = process.env.REACT_APP_API_ROOT;
  const userId = localStorage.getItem("userID");
  const token = localStorage.getItem("token");
  const [floorList, setFloorList] = useState([]);
  const [maxItems, setMaxItems] = useState(null);

  useEffect(() => {
    const fetchProjectInfo = async () => {
      const response = await fetch(
        `${apiRootSecond}/api/project_info/?project_id=${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        console.error("Failed to fetch project info:", response.statusText);
        return;
      }
      const data = await response.json();
      if (data.length > 0) {
        setFloorList(JSON.parse(data[0].floor_list));
      }
    };
    const fetchSurfaceInfo = async () => {
      const response = await fetch(
        `${apiRoot}/api/rooms?projectId=${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        console.error("Failed to fetch surface info:", response.statusText);
        return;
      }
      const data = await response.json();
      setMaxItems(data.maxItems);
    };

    fetchProjectInfo();
    fetchSurfaceInfo();
  }, [apiRoot, apiRootSecond, projectId, token]);

  return (
    <div>
      <RoomFileUpload
        heading1="Upload Your Room Schedule File"
        heading2={`Digital Twin File Uploader - Project ${projectId}`}
        fileUploadComponents={[
          {
            label: "Room Zip File",
            id: "scene-setup",
            uploadUrl: `${apiRoot}/rooms/upload_excel?project_id=${projectId}&user_id=${userId}&file_type=window`,
          },
        ]}
        apiText="Here is the floor list available on DB. Please ensure your windows file name contains the floor name."
        apiContextArg={floorList}
        noWindows={maxItems}
      />
    </div>
  );
};

export default RoomFootprint;
